import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

import ConNav from './conNav';
import Banner from './banner';
import ContactList from './contactList';

class Content extends React.PureComponent {
    // eslint-disable-next-line no-useless-constructor
    constructor() {
        super();
        this.conNavHeader = {
            navCenter: '联系我们',
            navRight: '凤凰新媒体',
        };
    }

    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.pageBody}>
                <div className={styles.page}>
                    <div className={styles.pageHead}>
                        <div className={styles.pageEnd}>
                            <div className={styles.myContent}>
                                <Chip
                                    id="162635"
                                    type="static"
                                    title="首图banner"
                                    groupName="首图banner"
                                    content={content}>
                                    <Banner />
                                </Chip>
                                <ConNav conNavHeader={this.conNavHeader} />
                                <div className={styles.Management}>
                                    <Chip
                                        id="162650"
                                        type="static"
                                        title="管理团队人员"
                                        groupName="管理团队人员"
                                        content={content}>
                                        <ContactList />
                                    </Chip>
                                </div>
                            </div>
                            <div className={styles.clear} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Content;
